"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("./");
const type_based_1 = require("../validators/type-based");
class TypeValidatorBuilderImpl extends _1.CommonValidatorBuilderImpl {
    constructor(validationRule) {
        super(validationRule);
    }
    isArray() {
        this.validationRule.addValidator(new type_based_1.IsArrayValidator());
        return new _1.CommonValidatorBuilderImpl(this.validationRule);
    }
    isBoolean() {
        this.validationRule.addValidator(new type_based_1.IsBooleanValidator());
        return new _1.CommonValidatorBuilderImpl(this.validationRule);
    }
    isDate() {
        this.validationRule.addValidator(new type_based_1.IsDateValidator());
        return new _1.DateValidatorBuilderImpl(this.validationRule);
    }
    isNumber() {
        this.validationRule.addValidator(new type_based_1.IsNumberValidator());
        return new _1.NumberValidatorBuilderImpl(this.validationRule);
    }
    isString() {
        this.validationRule.addValidator(new type_based_1.IsStringValidator());
        return new _1.StringValidatorBuilderImpl(this.validationRule);
    }
}
exports.TypeValidatorBuilderImpl = TypeValidatorBuilderImpl;
//# sourceMappingURL=TypeValidatorBuilderImpl.js.map